import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckNodeTypes } from '@api/consistencyCheck';

import { extractQueryParams } from '@utils/common';
import { optionsFormattedWithAvailability } from '@utils/formatter';

import { ICMMavenirVendor, TCMNodeTypesOptions } from '@interfaces/cmModule/cmModule';
import { TCMNodeVendorTechnology } from '@interfaces/cmModule/dto/cmModuleDTO';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_NODE_TYPES } from '@constants/queryKeys';

interface IUseConsistencyCheckNodeTypesReturnType {
	nodesTypesOptions: TSelectOption[];
	isLoadingNodeTypesOptions: boolean;
}

type TUseConsistencyCheckNodes = Partial<TCMNodeVendorTechnology> & ICMMavenirVendor

const useQueryConsistencyCheckNodeTypes = (
	params: TUseConsistencyCheckNodes,
): IUseConsistencyCheckNodeTypesReturnType => {
	const {
		vendor,
		technology,
		isMavenirVendor,
	} = params;

	const {
		data: nodesTypesOptions,
		isLoading: isLoadingNodeTypesOptions,
		isFetching: isFetchingNodeTypesOptions,
	} = useQuery<TCMNodeTypesOptions[] | undefined, TSelectOption[]>({
		queryKey: [
			CONSISTENCY_NODE_TYPES,
			{
				technology,
				vendor,
			},
		],
		queryFn: extractQueryParams(getConsistencyCheckNodeTypes),
		select: (options) => optionsFormattedWithAvailability(options || []),
		enabled: [vendor, technology, !isMavenirVendor],
		...refetchOptions,
	});

	return {
		nodesTypesOptions: nodesTypesOptions || [],
		isLoadingNodeTypesOptions: (isLoadingNodeTypesOptions && !!nodesTypesOptions)
			|| isFetchingNodeTypesOptions,
	};
};

export default useQueryConsistencyCheckNodeTypes;
